'use client';
import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';


const DiscoverIconSm = () => (
  <svg width="17" height="17" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="5" y="0" width="2" height="1"/><rect x="3" y="1" width="2" height="1"/><rect x="7" y="1" width="2" height="1"/>
    <rect x="2" y="2" width="1" height="1"/><rect x="9" y="2" width="1" height="1"/>
    <rect x="1" y="3" width="1" height="2"/><rect x="10" y="3" width="1" height="2"/>
    <rect x="0" y="5" width="1" height="2"/><rect x="11" y="5" width="1" height="2"/>
    <rect x="1" y="7" width="1" height="2"/><rect x="10" y="7" width="1" height="2"/>
    <rect x="2" y="9" width="1" height="1"/><rect x="9" y="9" width="1" height="1"/>
    <rect x="3" y="10" width="2" height="1"/><rect x="7" y="10" width="2" height="1"/>
    <rect x="5" y="11" width="2" height="1"/>
    <rect x="7" y="3" width="1" height="1"/><rect x="6" y="4" width="1" height="1"/>
    <rect x="5" y="5" width="2" height="2"/><rect x="5" y="7" width="1" height="1"/>
    <rect x="4" y="8" width="1" height="1"/>
  </svg>
);
const CollectionsIconSm = () => (
  <svg width="17" height="17" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="1" y="1" width="4" height="4"/><rect x="7" y="1" width="4" height="4"/>
    <rect x="1" y="7" width="4" height="4"/><rect x="7" y="7" width="4" height="4"/>
  </svg>
);
const BridgeIconSm = () => (
  <svg width="17" height="17" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="3" y="0" width="1" height="10"/><rect x="2" y="1" width="1" height="1"/>
    <rect x="4" y="1" width="1" height="1"/><rect x="1" y="2" width="1" height="1"/>
    <rect x="5" y="2" width="1" height="1"/><rect x="8" y="2" width="1" height="10"/>
    <rect x="7" y="9" width="1" height="1"/><rect x="9" y="9" width="1" height="1"/>
    <rect x="6" y="8" width="1" height="1"/><rect x="10" y="8" width="1" height="1"/>
  </svg>
);
const ActivityIconSm = () => (
  <svg width="17" height="17" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="0" y="6" width="2" height="1"/><rect x="2" y="4" width="1" height="2"/>
    <rect x="3" y="2" width="1" height="2"/><rect x="4" y="4" width="1" height="2"/>
    <rect x="5" y="6" width="1" height="2"/><rect x="6" y="8" width="1" height="2"/>
    <rect x="7" y="6" width="1" height="2"/><rect x="8" y="6" width="4" height="1"/>
  </svg>
);
const StudioIconSm = () => (
  <svg width="17" height="17" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="9" y="0" width="2" height="2"/><rect x="8" y="2" width="2" height="2"/>
    <rect x="7" y="3" width="2" height="2"/><rect x="6" y="4" width="2" height="2"/>
    <rect x="5" y="5" width="2" height="2"/><rect x="4" y="6" width="2" height="2"/>
    <rect x="3" y="7" width="2" height="2"/><rect x="2" y="8" width="2" height="2"/>
    <rect x="1" y="9" width="2" height="2"/><rect x="0" y="10" width="2" height="2"/>
    <rect x="0" y="9" width="1" height="1"/><rect x="10" y="2" width="1" height="1"/>
  </svg>
);
const ProfileIconSm = () => (
  <svg width="17" height="17" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="4" y="1" width="4" height="4"/><rect x="5" y="5" width="2" height="1"/>
    <rect x="3" y="7" width="6" height="1"/><rect x="2" y="8" width="8" height="1"/>
    <rect x="1" y="9" width="10" height="3"/>
  </svg>
);
const PointsIconSm = () => (
  <svg width="17" height="17" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="2" y="8" width="2" height="3"/><rect x="5" y="5" width="2" height="6"/>
    <rect x="8" y="2" width="2" height="9"/>
  </svg>
);

const mobileNavItems = [
  { href: '/', label: 'Discover', Icon: DiscoverIconSm },
  { href: '/collections', label: 'Collections', Icon: CollectionsIconSm },
  { href: '/bridge', label: 'Bridge', Icon: BridgeIconSm },
  { href: '/activity', label: 'Activity', Icon: ActivityIconSm },
  { href: '/studio', label: 'Studio', Icon: StudioIconSm },
  { href: '/my', label: 'Profile', Icon: ProfileIconSm },
  { href: '/points', label: 'Points', Icon: PointsIconSm },
];

export default function MobileNav() {
  return (
    <nav className="rail-bottom">
      {mobileNavItems?.map(({href,label,Icon}) => (
        <Link key={href} href={href} data-on="0">
          <Icon />
          {label}
        </Link>
      ))}
    </nav>
  );
}
